import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMe } from '../../hooks/useMe';

import Nav from '../../layouts/Nav';
import Login from '../../layouts/Login';

import "./style.css"

function Body() {
    const getMe = useMe();
    const state = useSelector(state => state.profil);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            await getMe();
            setLoading(false);
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) return null;

    return state && (
        <div className="body_comp">
            {state._id === '' && <Login />}

            {state._id !== '' && <Nav />}
            {state._id !== '' && <Outlet />}
        </div>
    )
}

export default Body;